import { platformOf, storeLinks } from "../stores.ts";
import { h } from "./dom.ts";

/** The visitor's own store, or both on a computer, as links with class `cls`. */
export function appLinks(urls: { appStoreUrl: string; playStoreUrl: string }, label: string, cls: string): HTMLElement {
  const links = storeLinks(urls, platformOf(navigator.userAgent, navigator.maxTouchPoints), label);
  return h("div", { class: "stores" }, ...links.map((l) => h("a", { class: cls, href: l.href }, l.label)));
}
